import productCatalogue from './product_catalogue.pdf';

export default { productCatalogue };